// GENERADO por app/scripts/piezas_metricas_generar.ts desde app/shared/piezas/fuente/*.woff (Instrument Sans, OFL). No editar a mano:
// la prueba P15 (app/scripts/piezas_test.ts) la vuelve a generar y falla si difiere.

/** Unidades por eme de la fuente. */
export const UNIDADES = 1000;
/** Ascendente y descendente (tabla hhea), en unidades: la altura de una línea de texto. */
export const ASCENDENTE = 970;
export const DESCENDENTE = -250;
export const PESOS = [400, 500, 600, 700] as const;
/** [punto de código, ancho con peso 400, 500, 600, 700], en unidades, ordenado por punto de código. */
export const ANCHOS: readonly (readonly [number, number, number, number, number])[] = [
  [32, 200, 197, 193, 190],
  [33, 273, 284, 295, 306],
  [34, 384, 417, 449, 482],
  [35, 716, 721, 727, 732],
  [36, 608, 623, 637, 652],
  [37, 786, 786, 786, 786],
  [38, 755, 761, 768, 774],
  [39, 232, 244, 256, 268],
  [40, 406, 423, 439, 456],
  [41, 406, 423, 439, 456],
  [42, 408, 419, 430, 441],
  [43, 531, 538, 544, 551],
  [44, 255, 265, 275, 285],
  [45, 506, 499, 493, 486],
  [46, 255, 265, 275, 285],
  [47, 443, 444, 444, 445],
  [48, 666, 671, 677, 682],
  [49, 391, 389, 387, 385],
  [50, 545, 551, 557, 563],
  [51, 574, 577, 579, 582],
  [52, 600, 607, 615, 622],
  [53, 574, 578, 581, 585],
  [54, 599, 607, 615, 623],
  [55, 532, 546, 561, 575],
  [56, 582, 590, 598, 606],
  [57, 610, 615, 619, 624],
  [58, 255, 265, 275, 285],
  [59, 255, 265, 275, 285],
  [60, 531, 538, 544, 551],
  [61, 531, 538, 544, 551],
  [62, 531, 538, 544, 551],
  [63, 567, 574, 580, 587],
  [64, 853, 860, 867, 874],
  [65, 728, 731, 733, 736],
  [66, 636, 640, 645, 649],
  [67, 741, 744, 747, 750],
  [68, 752, 753, 755, 756],
  [69, 638, 634, 630, 626],
  [70, 602, 598, 594, 590],
  [71, 765, 764, 764, 763],
  [72, 736, 731, 725, 720],
  [73, 254, 254, 254, 254],
  [74, 455, 441, 427, 413],
  [75, 692, 702, 712, 722],
  [76, 588, 589, 589, 590],
  [77, 906, 902, 898, 894],
  [78, 736, 731, 725, 720],
  [79, 786, 790, 794, 798],
  [80, 656, 661, 667, 672],
  [81, 787, 796, 806, 815],
  [82, 656, 660, 664, 668],
  [83, 608, 623, 637, 652],
  [84, 648, 656, 664, 672],
  [85, 712, 708, 704, 700],
  [86, 728, 731, 733, 736],
  [87, 1089, 1088, 1087, 1086],
  [88, 688, 697, 707, 716],
  [89, 676, 688, 700, 712],
  [90, 623, 627, 631, 635],
  [91, 406, 423, 439, 456],
  [92, 443, 444, 444, 445],
  [93, 406, 423, 439, 456],
  [94, 531, 538, 544, 551],
  [95, 426, 446, 466, 486],
  [96, 354, 354, 354, 354],
  [97, 533, 546, 558, 571],
  [98, 606, 613, 621, 628],
  [99, 533, 543, 552, 562],
  [100, 606, 613, 621, 628],
  [101, 564, 567, 571, 574],
  [102, 354, 362, 370, 378],
  [103, 606, 613, 621, 628],
  [104, 599, 606, 612, 619],
  [105, 240, 250, 260, 270],
  [106, 240, 250, 260, 270],
  [107, 535, 546, 558, 569],
  [108, 240, 250, 260, 270],
  [109, 922, 931, 941, 950],
  [110, 599, 606, 612, 619],
  [111, 584, 591, 597, 604],
  [112, 606, 613, 621, 628],
  [113, 606, 613, 621, 628],
  [114, 375, 383, 390, 398],
  [115, 473, 483, 494, 504],
  [116, 377, 392, 406, 421],
  [117, 589, 596, 604, 611],
  [118, 523, 530, 536, 543],
  [119, 767, 783, 800, 816],
  [120, 551, 569, 587, 605],
  [121, 523, 530, 536, 543],
  [122, 496, 505, 513, 522],
  [123, 406, 423, 439, 456],
  [124, 242, 238, 234, 230],
  [125, 406, 423, 439, 456],
  [126, 531, 538, 544, 551],
  [160, 200, 197, 193, 190],
  [161, 273, 284, 295, 306],
  [162, 533, 543, 552, 562],
  [163, 588, 594, 600, 606],
  [165, 616, 628, 640, 652],
  [167, 498, 509, 519, 530],
  [168, 441, 464, 487, 510],
  [169, 850, 837, 823, 810],
  [170, 371, 373, 375, 377],
  [171, 494, 521, 547, 574],
  [174, 850, 837, 823, 810],
  [175, 411, 411, 411, 411],
  [176, 386, 379, 373, 366],
  [180, 354, 354, 354, 354],
  [182, 711, 687, 663, 639],
  [183, 103, 124, 144, 165],
  [184, 301, 301, 301, 301],
  [186, 414, 413, 411, 410],
  [187, 494, 521, 547, 574],
  [191, 567, 574, 580, 587],
  [192, 728, 731, 733, 736],
  [193, 728, 731, 733, 736],
  [194, 728, 731, 733, 736],
  [195, 728, 731, 733, 736],
  [196, 728, 731, 733, 736],
  [197, 728, 731, 733, 736],
  [198, 936, 952, 967, 983],
  [199, 741, 744, 747, 750],
  [200, 638, 634, 630, 626],
  [201, 638, 634, 630, 626],
  [202, 638, 634, 630, 626],
  [203, 638, 634, 630, 626],
  [204, 254, 254, 254, 254],
  [205, 254, 254, 254, 254],
  [206, 254, 254, 254, 254],
  [207, 254, 254, 254, 254],
  [208, 752, 759, 765, 772],
  [209, 736, 731, 725, 720],
  [210, 786, 790, 794, 798],
  [211, 786, 790, 794, 798],
  [212, 786, 790, 794, 798],
  [213, 786, 790, 794, 798],
  [214, 786, 790, 794, 798],
  [215, 531, 538, 544, 551],
  [216, 786, 790, 794, 798],
  [217, 712, 708, 704, 700],
  [218, 712, 708, 704, 700],
  [219, 712, 708, 704, 700],
  [220, 712, 708, 704, 700],
  [221, 676, 688, 700, 712],
  [222, 656, 660, 664, 668],
  [223, 612, 621, 631, 640],
  [224, 533, 546, 558, 571],
  [225, 533, 546, 558, 571],
  [226, 533, 546, 558, 571],
  [227, 533, 546, 558, 571],
  [228, 533, 546, 558, 571],
  [229, 533, 546, 558, 571],
  [230, 865, 872, 880, 887],
  [231, 533, 543, 552, 562],
  [232, 564, 567, 571, 574],
  [233, 564, 567, 571, 574],
  [234, 564, 567, 571, 574],
  [235, 564, 567, 571, 574],
  [236, 240, 250, 260, 270],
  [237, 240, 250, 260, 270],
  [238, 240, 250, 260, 270],
  [239, 240, 250, 260, 270],
  [240, 592, 600, 608, 616],
  [241, 599, 606, 612, 619],
  [242, 584, 591, 597, 604],
  [243, 584, 591, 597, 604],
  [244, 584, 591, 597, 604],
  [245, 584, 591, 597, 604],
  [246, 584, 591, 597, 604],
  [247, 531, 538, 544, 551],
  [248, 584, 591, 597, 604],
  [249, 589, 596, 604, 611],
  [250, 589, 596, 604, 611],
  [251, 589, 596, 604, 611],
  [252, 589, 596, 604, 611],
  [253, 523, 530, 536, 543],
  [254, 606, 613, 621, 628],
  [255, 523, 530, 536, 543],
  [256, 728, 731, 733, 736],
  [257, 533, 546, 558, 571],
  [258, 728, 731, 733, 736],
  [259, 533, 546, 558, 571],
  [260, 728, 731, 733, 736],
  [261, 533, 546, 558, 571],
  [262, 741, 744, 747, 750],
  [263, 533, 543, 552, 562],
  [266, 741, 744, 747, 750],
  [267, 533, 543, 552, 562],
  [268, 741, 744, 747, 750],
  [269, 533, 543, 552, 562],
  [270, 752, 753, 755, 756],
  [271, 651, 676, 701, 726],
  [272, 752, 759, 765, 772],
  [273, 606, 613, 621, 628],
  [274, 638, 634, 630, 626],
  [275, 564, 567, 571, 574],
  [278, 638, 634, 630, 626],
  [279, 564, 567, 571, 574],
  [280, 638, 634, 630, 626],
  [281, 564, 567, 571, 574],
  [282, 638, 634, 630, 626],
  [283, 564, 567, 571, 574],
  [286, 765, 764, 764, 763],
  [287, 606, 613, 621, 628],
  [288, 765, 764, 764, 763],
  [289, 606, 613, 621, 628],
  [290, 765, 764, 764, 763],
  [291, 606, 613, 621, 628],
  [294, 736, 741, 747, 752],
  [295, 599, 606, 612, 619],
  [298, 254, 254, 254, 254],
  [299, 240, 250, 260, 270],
  [302, 254, 254, 254, 254],
  [303, 240, 250, 260, 270],
  [304, 254, 254, 254, 254],
  [305, 240, 250, 260, 270],
  [306, 709, 695, 681, 667],
  [307, 477, 494, 511, 528],
  [310, 692, 702, 712, 722],
  [311, 535, 546, 558, 569],
  [313, 588, 589, 589, 590],
  [314, 240, 250, 260, 270],
  [315, 588, 589, 589, 590],
  [316, 240, 250, 260, 270],
  [317, 588, 589, 589, 590],
  [318, 285, 313, 340, 368],
  [321, 588, 591, 593, 596],
  [322, 260, 277, 293, 310],
  [323, 736, 731, 725, 720],
  [324, 599, 606, 612, 619],
  [325, 736, 731, 725, 720],
  [326, 599, 606, 612, 619],
  [327, 736, 731, 725, 720],
  [328, 599, 606, 612, 619],
  [330, 736, 728, 720, 712],
  [331, 599, 606, 612, 619],
  [332, 786, 790, 794, 798],
  [333, 584, 591, 597, 604],
  [336, 786, 790, 794, 798],
  [337, 584, 591, 597, 604],
  [338, 1064, 1073, 1081, 1090],
  [339, 946, 947, 948, 949],
  [340, 656, 660, 664, 668],
  [341, 375, 383, 390, 398],
  [342, 656, 660, 664, 668],
  [343, 375, 383, 390, 398],
  [344, 656, 660, 664, 668],
  [345, 375, 383, 390, 398],
  [346, 608, 623, 637, 652],
  [347, 473, 483, 494, 504],
  [350, 608, 623, 637, 652],
  [351, 473, 483, 494, 504],
  [352, 608, 623, 637, 652],
  [353, 473, 483, 494, 504],
  [356, 648, 656, 664, 672],
  [357, 377, 392, 406, 421],
  [362, 712, 708, 704, 700],
  [363, 589, 596, 604, 611],
  [364, 712, 708, 704, 700],
  [365, 589, 596, 604, 611],
  [366, 712, 708, 704, 700],
  [367, 589, 596, 604, 611],
  [368, 712, 708, 704, 700],
  [369, 589, 596, 604, 611],
  [370, 712, 708, 704, 700],
  [371, 589, 596, 604, 611],
  [372, 1089, 1088, 1087, 1086],
  [373, 767, 783, 800, 816],
  [374, 676, 688, 700, 712],
  [375, 523, 530, 536, 543],
  [376, 676, 688, 700, 712],
  [377, 623, 627, 631, 635],
  [378, 496, 505, 513, 522],
  [379, 623, 627, 631, 635],
  [380, 496, 505, 513, 522],
  [381, 623, 627, 631, 635],
  [382, 496, 505, 513, 522],
  [461, 728, 731, 733, 736],
  [462, 533, 546, 558, 571],
  [536, 608, 623, 637, 652],
  [537, 473, 483, 494, 504],
  [538, 648, 656, 664, 672],
  [539, 377, 392, 406, 421],
  [567, 240, 250, 260, 270],
  [710, 433, 433, 433, 433],
  [711, 433, 433, 433, 433],
  [730, 335, 335, 335, 335],
  [732, 452, 452, 452, 452],
  [733, 414, 414, 414, 414],
  [7808, 1089, 1088, 1087, 1086],
  [7809, 767, 783, 800, 816],
  [7810, 1089, 1088, 1087, 1086],
  [7811, 767, 783, 800, 816],
  [7812, 1089, 1088, 1087, 1086],
  [7813, 767, 783, 800, 816],
  [7838, 713, 714, 716, 717],
  [7922, 676, 688, 700, 712],
  [7923, 523, 530, 536, 543],
  [8211, 586, 593, 599, 606],
  [8212, 886, 893, 899, 906],
  [8216, 255, 265, 275, 285],
  [8217, 255, 265, 275, 285],
  [8218, 248, 260, 271, 283],
  [8220, 409, 440, 471, 502],
  [8221, 409, 440, 471, 502],
  [8222, 398, 431, 464, 497],
  [8226, 306, 321, 336, 351],
  [8230, 655, 692, 728, 765],
  [8249, 334, 347, 361, 374],
  [8250, 334, 347, 361, 374],
  [8364, 701, 708, 715, 722],
  [8482, 850, 853, 855, 858],
  [8593, 780, 793, 807, 820],
  [8595, 780, 793, 807, 820],
  [8722, 531, 538, 544, 551],
];
